"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharesCryptoCache = void 0;
/**
 * Provides caching for share crypto material.
 *
 * The cache is responsible for serialising and deserialising share
 * crypto material.
 *
 * The share crypto materials are cached so the updates to the root
 * nodes can be decrypted without the need to fetch the share keys
 * from the server again. Otherwise the rest of the tree requires
 * only the root node, thus share cache is not needed.
 */
class SharesCryptoCache {
    driveCache;
    constructor(driveCache) {
        this.driveCache = driveCache;
        this.driveCache = driveCache;
    }
    async setShareKey(shareId, key) {
        await this.driveCache.setEntity(getCacheUid(shareId), key);
    }
    async getShareKey(shareId) {
        return this.driveCache.getEntity(getCacheUid(shareId));
    }
    async removeShareKey(shareIds) {
        await this.driveCache.removeEntities(shareIds.map(getCacheUid));
    }
}
exports.SharesCryptoCache = SharesCryptoCache;
function getCacheUid(shareId) {
    return `shareKey-${shareId}`;
}
//# sourceMappingURL=cryptoCache.js.map